import MapUtils from '../collections/MapUtils';
Map.prototype.keysAsEnumerable = function () {
    return MapUtils.enumerableKeys(this);
};
Map.prototype.valuesAsEnumerable = function () {
    return MapUtils.enumerableValues(this);
};
Map.prototype.toEnumerable = function () {
    return MapUtils.toEnumerable(this);
};
//# sourceMappingURL=MapExtensions.js.map